import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PropertyHeader = ({ property }) => {
  const formatPrice = (price) => {
    if (price >= 10000000) {
      return `₹${(price / 10000000).toFixed(1)} Cr`;
    } else if (price >= 100000) {
      return `₹${(price / 100000).toFixed(1)} L`;
    }
    return `₹${price.toLocaleString()}`;
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'available':
        return 'bg-success text-success-foreground';
      case 'sold':
        return 'bg-error text-error-foreground';
      case 'rented':
        return 'bg-warning text-warning-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-surface p-6 rounded-lg shadow-property-card">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        {/* Property Title and Location */}
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h1 className="text-2xl lg:text-3xl font-bold text-text-primary">
              {property.title}
            </h1>
            {property.ownerVerified && (
              <div className="flex items-center gap-1 bg-success/10 text-success px-2 py-1 rounded-full text-xs">
                <Icon name="Shield" size={12} />
                <span>Verified Owner</span>
              </div>
            )}
          </div>
          
          <div className="flex items-center gap-2 text-text-secondary mb-4">
            <Icon name="MapPin" size={16} />
            <span>{property.location}</span>
          </div>

          {/* Key Details */}
          <div className="flex flex-wrap items-center gap-4 text-sm">
            <div className="flex items-center gap-1">
              <Icon name="Home" size={16} className="text-text-secondary" />
              <span className="font-medium">{property.configuration}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Maximize" size={16} className="text-text-secondary" />
              <span className="font-medium">{property.area} sq ft</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={16} className="text-text-secondary" />
              <span className="font-medium">Built in {property.yearBuilt}</span>
            </div>
          </div>
        </div>

        {/* Price and Status */}
        <div className="flex flex-col items-start lg:items-end gap-3">
          <div className="text-right">
            <div className="text-3xl font-bold text-primary">
              {formatPrice(property.price)}
            </div>
            {property.type === 'rent' && (
              <div className="text-text-secondary text-sm">per month</div>
            )}
            {property.type === 'sale' && property.pricePerSqFt && (
              <div className="text-text-secondary text-sm">
                ₹{property.pricePerSqFt.toLocaleString()}/sq ft
              </div>
            )}
          </div>

          <div className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(property.status)}`}>
            {property.status}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3 mt-6 pt-6 border-t border-border">
        <Button
          variant="default"
          iconName="Phone"
          iconPosition="left"
          className="flex-1"
        >
          Call Owner
        </Button>
        <Button
          variant="secondary"
          iconName="MessageCircle"
          iconPosition="left"
          className="flex-1"
        >
          WhatsApp
        </Button>
        <Button
          variant="outline"
          iconName="Calendar"
          iconPosition="left"
          className="flex-1"
        >
          Schedule Visit
        </Button>
        <Button
          variant="ghost"
          iconName="Heart"
          iconPosition="left"
        >
          Save
        </Button>
        <Button
          variant="ghost"
          iconName="Share"
          iconPosition="left"
        >
          Share
        </Button>
      </div>
    </div>
  );
};

export default PropertyHeader;